// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1dGRD","title":"Header_title__262ZV","side":"Header_side__E0ddO"};